import { gql } from 'graphql-tag'

import { FRAGMENT_MESSAGE_EMBED_V1_MESSAGE } from '@/components/Conversation/MessageEmbedV1/MessageEmbedV1.hasura'

import { FRAGMENT_MESSAGE_OPERATOR_V1_MESSAGE } from './MessageOperatorV1.hasura'
import { FRAGMENT_MESSAGE_PLAIN_V1_MESSAGE } from './MessagePlainV1.hasura'

export const FRAGMENT_MESSAGE_MESSAGE = gql`
  fragment MessageMessage on message {
    id
    type
    body_safe
    updated_at
    ...MessageEmbedV1Message
    ...MessageOperatorV1Message
    ...MessagePlainV1Message
  }
  ${FRAGMENT_MESSAGE_EMBED_V1_MESSAGE}
  ${FRAGMENT_MESSAGE_PLAIN_V1_MESSAGE}
  ${FRAGMENT_MESSAGE_OPERATOR_V1_MESSAGE}
`
